import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { FormGroup, Label } from 'reactstrap';
import { getClientEngagementList as onGetClientEngagementList } from 'store/actions';
import { useFormikContext } from 'formik'; // ✅ Import useFormikContext
import PropTypes from 'prop-types';

const ClientEngagementList = ({ name, clientId, agentId, typeId, statusId, selectedData }) => {
    const dispatch = useDispatch();
    const { values, errors, touched, setFieldValue, handleBlur } = useFormikContext();

    const { clientengagements } = useSelector(state => ({
        clientengagements: state.Clients.clientengagements,
    }));

    useEffect(() => {
        if (clientId && agentId) { 
            dispatch(onGetClientEngagementList(clientId, agentId, typeId, statusId));
        }
    }, [dispatch, clientId, agentId, typeId, statusId]);

    const getType = (type) => type === 1 ? 'Rent' : type === 2 ? 'Purchase' : 'Unknown Type';
    const getSType = (type) => type === 1 ? 'Sell' : type === 2 ? 'Lease' : 'Unknown Type';

    const formatYYMM = (dateStr) => {
        if (!dateStr) return "0000";
        const date = new Date(dateStr);
        const yy = String(date.getFullYear()).slice(2);
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        return `${yy}${mm}`;
    };

    
    const fieldError = name.split('.').reduce((acc, key) => acc?.[key], errors);
    const fieldTouched = name.split('.').reduce((acc, key) => acc?.[key], touched);
    const fieldValue = name.split('.').reduce((acc, key) => acc?.[key], values);

    return (
        <FormGroup className="mb-3">
            <Label htmlFor={name}>Deal ID</Label>
            <select
                name={name}
                className={`form-control ${fieldError && fieldTouched ? "is-invalid" : ""}`}
                onChange={(e) => setFieldValue(name, e.target.value)}
                onBlur={handleBlur}
                value={fieldValue || ""}
                disabled={selectedData}
            >
              {clientengagements?.length > 1 && <option value="">Select</option>}
                {clientengagements?.map(option => {
                    if (option.clientEngagementStatus === 3 && option.id !== Number(fieldValue)) {
                        return null;
                    }

                    const label = option.isBuyer
                        ? `${getType(option.buyerType)} - (${option.id} - ${formatYYMM(option.startDate)})`
                        : `${option.contactName} - ${getSType(option.sellerType)} - (${option.id} - ${formatYYMM(option.startDate)})`;

                    return (
                        <option key={option.id} value={option.id}>
                            {label}
                        </option>
                    );
                })}
            </select>
            {fieldError && fieldTouched && (
                <div className="invalid-feedback">{fieldError}</div>
            )}
        </FormGroup>
    );
};

ClientEngagementList.propTypes = {
    name: PropTypes.string.isRequired,  
    clientId: PropTypes.string.isRequired,
    agentId: PropTypes.string.isRequired,
    typeId: PropTypes.number,
    statusId: PropTypes.number,
    selectedData: PropTypes.number
};

export default ClientEngagementList;
